<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <div class="flex justify-between">
      <div class="flex justify-between">
        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.</p>
      </div>
      <div class="flex justify-end">
        <div v-if="!isEditing">
          <vs-button
            icon="edit"
            @click="startEditing"
            type="relief"
            color="primary"
            class="mr-3"
          >
            Edit pouring categories
          </vs-button>
        </div>
        <div v-else>
          <vs-row>
            <vs-button
              icon="save"
              @click="savePouringCategories"
              type="relief"
              color="primary"
              class="mr-3"
            >
              Save pouring categories
            </vs-button>
            <vs-button
              icon="close"
              @click="cancelEdit"
              type="border"
              color="primary"
              class="mr-3"
            >
              Cancel
            </vs-button>
          </vs-row>
        </div>
      </div>
    </div>

    <!-- table -->
    <div class="pouring-product-table">
      <vs-table
        ref="table"
        class="mt-4"
        v-model="selected"
        pagination
        search
        :max-items="10"
        :data="mappedVenueStock"
      >
        <template slot="header">
          <div class="flex mb-2">
            <vs-select
              v-model="filters.pouringCategory"
              placeholder="Filter by pouring category"
            >
              <vs-select-item key="noItem" :value="null" text="All" />
              <vs-select-item
                :key="item.venueProductCategoryId.id"
                :value="item.venueProductCategoryId.id"
                :text="item.name"
                v-for="item in pouringCategories"
              />
            </vs-select>
          </div>
          <vs-spacer />
        </template>
        <template slot="thead">
          <vs-th sort-key="number">Product id</vs-th>
          <vs-th sort-key="stockProductName">Name</vs-th>
          <vs-th sort-key="pouringCategory">Pouring category</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div
                  class="
                    product-name
                    font-medium
                    truncate
                    flex flex-row
                    items-center
                  "
                >
                  <img width="40" :src="ProductIcon" />
                  <p class="ml-4">{{ tr.stockProductId.id }}</p>
                </div>
              </vs-td>
              <vs-td>
                <div>
                  {{ tr.displayName }}
                </div>
              </vs-td>
              <vs-td>
                <div v-if="isEditing">
                  <vs-select
                    :value="
                      tr.pouringCategory
                        ? tr.pouringCategory.venueProductCategoryId.id
                        : null
                    "
                    @input="(e) => onChangedPouringCategory(tr, e)"
                    placeholder="No pouring category"
                  >
                    <vs-select-item
                      :key="item.venueProductCategoryId.id"
                      :value="item.venueProductCategoryId.id"
                      :text="item.name"
                      v-for="item in pouringCategories"
                    />
                  </vs-select>
                </div>
                <div v-else>
                  <vs-chip v-if="tr.pouringCategory" color="primary">
                    {{ tr.pouringCategory.venueProductCategoryName }}
                  </vs-chip>
                  <vs-chip v-else><i> No pouring category </i></vs-chip>
                </div>
              </vs-td>
              <vs-td>
                <feather-icon
                  v-if="!isEditing"
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-4"
                  @click.stop="removeCategory(tr.stockProductId.id)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";
import moment from "moment";

export default {
  data() {
    return {
      selected: [],
      filterByLocationId: "",
      isLoading: true,
      ProductIcon,

      isEditing: false,
      changedProductCategories: [],

      filters: {
        pouringCategory: null,
      },
    };
  },
  methods: {
    startEditing() {
      this.isEditing = true;
      this.changedProductCategories = [];
    },
    cancelEdit() {
      this.isEditing = false;
    },
    async savePouringCategories() {
      console.log("SAVING", this.changedProductCategories);

      const dto = {
        venueProductCategories: this.changedProductCategories,
      };

      try {
        const result = await this.$store.dispatch(
          "pimVenues/updateVenueProductCategories",
          {
            venueId: this.activeVenueId,
            dto,
          }
        );

        this.$vs.notify({
          title: "Pouring categories saved",
          text: "The pouring category assignments has been saved",
        });

        await this.$store.dispatch("pimVenues/getVenue", this.activeVenueId);
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Categories not saved",
          text: err,
          time: 4000,
        });
      }

      this.isEditing = false;
    },
    onChangedPouringCategory(product, pouringCategoryId) {
      // Change it to persist state:
      this.venueAllProducts.find(
        (x) => x.stockProductId.id === product.stockProductId.id
      ).pouringCategory = this.pouringCategories.find(
        (x) => x.venueProductCategoryId.id === pouringCategoryId
      );

      //Remove product from changedProductCategories if it already exists
      this.changedProductCategories = this.changedProductCategories.filter(
        (x) => x.stockProductId !== product.stockProductId.id
      );

      // Then add the change
      this.changedProductCategories.push({
        stockProductId: product.stockProductId.id,
        venueProductCategoryId: pouringCategoryId,
      });
    },

    async removeCategory(productId) {
      const dto = {
        stockProductIds: [productId],
      };

      try {
        const result = await this.$store.dispatch(
          "pimVenues/deleteVenueProductCategories",
          {
            venueId: this.activeVenueId,
            dto,
          }
        );

        this.$vs.notify({
          title: "Pouring categories deleted",
          text: "The pouring category assignments has been deleted",
        });

        await this.$store.dispatch("pimVenues/getVenue", this.activeVenueId);
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Categories not deleted",
          text: err,
          time: 4000,
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      activeVenueId: "venues/activeVenueId",

      venueAllProducts: "pimVenues/venueAllProducts",
      venuePouringCategoryAssignments:
        "pimVenues/venuePouringCategoryAssignments",

      pouringCategories: "venueProductCategories/pouringCategories",
    }),
    mappedVenueStock() {
      return this.venueAllProducts
        .filter((e) => {
          const pouringCategory = this.venuePouringCategoryAssignments.find(
            (x) => x.stockProductId.id === e.stockProductId.id
          );

          if (this.filters.pouringCategory) {
            return (
              pouringCategory &&
              pouringCategory.venueProductCategoryId.id ===
                this.filters.pouringCategory
            );
          }

          return true;
        })
        .map((e) => {
          const pouringCategory = this.venuePouringCategoryAssignments.find(
            (x) => x.stockProductId.id === e.stockProductId.id
          );

          return {
            ...e,
            pouringCategory,
          };
        });
    },
  },

  async created() {
    this.isLoading = true;

    try {
      await Promise.all([
        this.$store.dispatch("venueProductCategories/getPouringCategories"),
        this.$store.dispatch("pimVenues/getVenue", this.activeVenueId),
      ]);
    } catch (err) {
      let message = err;
      if (err.error) message = err.error;

      this.$vs.notify({
        title: "Could not load",
        text: message,
        color: "danger",
        time: 5000,
      });
    } finally {
      this.isLoading = false;
    }
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

.pouring-product-table {
  .is-selected {
    background: #fff !important;
    box-shadow: none !important;
  }
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
  }
}
</style>
